<template>
  <div class="myDiv">
    <div class="invoiceBox">
      <div class="reson" v-if="postdata.AUDIT_STATUS==2">
        <span>{{postdata.FAILURE_REASON}}</span>
      </div>
      <div class="invoiceInfo">
        <div class="invoiceUrl" v-if="postdata.AUDIT_STATUS==1">
          <img :src="postdata.INVOICE_IMAGE_URL" />
          <div class="urlHandle" @click="urlHandle">
            <span>点击查看发票</span>
          </div>
          <div class="invoiceDownLoad" @click="emailHandle">
            <span class="iconfont icon-download"></span>
          </div>
        </div>
        <!-- <p v-if="postdata.INVOICE_TYPE=='增值税专用发票'">发票信息</p> -->
         <p v-if="postdata.AUDIT_STATUS!==1">发票信息</p>
         <div style="padding-top:10px">
          <div class="invoiceRows">
            <span>订单编号</span>
            <span>&nbsp;{{postdata.SAMPLE_ORDER}}</span>
          </div>
          <div class="invoiceRows">
            <span>申请时间</span>
            <span>&nbsp;{{postdata.APPLY_DATE}}</span>
          </div>
          <div class="invoiceRows" v-if='postdata.AUDIT_STATUS==1'>
            <span>开票时间</span>
            <span>&nbsp;{{postdata.INVOICING_TIME}}</span>
          </div>
          <div class="invoiceRows">
            <span>发票类型</span>
            <span>&nbsp;{{postdata.INVOICE_TYPE}}</span>
          </div>
          <div class="invoiceRows">
            <span>发票内容</span>
            <span>&nbsp;{{postdata.INVOICE_CONTENT}}</span>
          </div>
          <div class="invoiceRows">
            <span>发票抬头类型</span>
            <span>&nbsp;{{postdata.INVOICE_HEADER_TYPE=='1'?'个人':'单位'}}</span>
          </div>
          <div class="invoiceRows">
            <span>抬头名称</span>
            <span>&nbsp;{{postdata.INVOICE_TITLE}}</span>
          </div>
          <template v-if="postdata.INVOICE_TYPE=='增值税专用发票'">
            <div class="invoiceRows">
            <span>纳税识别号</span>
            <span>&nbsp;{{postdata.TAXER_NO}}</span>
            </div>
            <div class="invoiceRows">
              <span>注册地址</span>
              <span>&nbsp;{{postdata.ADDRESS_TEL}}</span>
            </div>
            <div class="invoiceRows">
              <span>注册电话</span>
              <span>&nbsp;{{postdata.TEL}}</span>
            </div>
            <div class="invoiceRows">
              <span>开户银行</span>
              <span>&nbsp;{{postdata.BANK}}</span>
            </div>
            <div class="invoiceRows">
              <span>银行账号</span>
              <span>&nbsp;{{postdata.PAY_NO}}</span>
            </div>
          </template>
          <div class="invoiceRows">
            <span>电子邮箱</span>
            <span style="word-break: break-all;">&nbsp;{{postdata.EMAIL}}</span>
          </div>
           <!-- <div class="invoiceRows">
            <span>提前开票原因</span>
            <span>{{postdata.BEFORE_INVOICE_REASON}}</span>
          </div> -->
          <div class="invoiceRows">
            <span>开票备注</span>
            <span>&nbsp;{{postdata.REMARK}}</span>
          </div>
        </div>
      </div>
      <div class="invoiceInfo" v-if="postdata.INVOICE_TYPE=='增值税专用发票'">
        <p>邮寄信息</p>
        <div style="padding-top:10px">
          <div class="invoiceRows">
            <span>发票收件人姓名</span>
            <span>&nbsp;{{postdata.INVOICE_RECIPIENT_NAME}}</span>
          </div>
          <div class="invoiceRows">
            <span>发票收件人电话</span>
            <span>&nbsp;{{postdata.INVOICE_RECIPIENT_PHONE}}</span>
          </div>
          <div class="invoiceRows">
            <span>发票收件人地址</span>
            <span>&nbsp;{{postdata.INVOICE_RECIPIENT_ADDRESS}}</span>
          </div>
        </div>
      </div>

    </div>
    <!-- <div class="btns" v-if="postdata.AUDIT_STATUS==2" @click="editHandle">
      <span>修改</span>
    </div> -->
    <!-- <div class="sendEmail" v-if="isPop">
      <div class="emailBox">
        <div class="pr">
          <p>发送发票至邮箱</p>
          <p>邮箱地址</p>
          <input type="email" name="" id="" v-model="email_value">
        </div>
        <div class="cancleBtn">
          <span @click="isPop=false">取消</span>
          <span @click="sendCheckHandle">发送</span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import isiOS from "../../../utils/iosAn";
  import { Toast } from "vant";
  import {sendRequest} from '../../../api/order'
  import '../../../assets/iconfonts/iconfont.css'
  export default {
    name: '',
    components: {},
    props: {},
    data() {
      return {
        // 发送邮箱默认隐藏
        isPop:false,

        // 邮箱
        isMail:'0',
        // 邮箱值
        email:'',
        sessionId:'',
        postdata:{
          PAY_AMOUNT:'',
          BEFORE_INVOICE_REASON:'',
          FAILURE_REASON:'',
          SAMPLE_ORDER:'',
          // 2 驳回  1 电子通过  纸质通过   
          AUDIT_STATUS:'1',
          invoiceImgUrl: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fp4.itc.cn%2Fq_70%2Fimages03%2F20210401%2F5b59ed9e9e6a4bd38f6b52c784830621.png&refer=http%3A%2F%2Fp4.itc.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1659947255&t=3f6f768bf38e31a9fe149c82ae3e6c1d'
        }
      }
    },
    watch: {},
    computed: {},
    methods: {
    emailHandle(){
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({isMail: this.isMail,email:this.email});
      } else {
        window.android.JSCallNative(JSON.stringify({ isMail: this.isMail,email:this.email }));
      }
    },
    urlHandle(){
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({invoiceImgUrl: this.postdata.INVOICE_IMAGE_URL});
      } else {
        window.android.JSCallNative(JSON.stringify({ invoiceImgUrl: this.postdata.INVOICE_IMAGE_URL }));
      }
    },
    // 取url参数
    getUrlParams(url) {
      let urlStr = url.split("?")[1];
      const urlSearchParams = new URLSearchParams(urlStr);
      const result = Object.fromEntries(urlSearchParams.entries());
      return result;
    },
    // 重新申请
    // editHandle(){
    //   if (isiOS) {
    //     window.webkit.messageHandlers.JSCallNative.postMessage({AFTER_PRICE: this.postdata.PAY_AMOUNT,INVOIVE_AUDIT_STATUS:this.postdata.AUDIT_STATUS,CUSTOMER_ORDER_CODE:this.postdata.CUSTOMER_ORDER_CODE,sessionId:this.sessionId});
    //   } else {
    //     window.android.JSCallNative(JSON.stringify({AFTER_PRICE: this.postdata.PAY_AMOUNT,INVOIVE_AUDIT_STATUS:this.postdata.AUDIT_STATUS,CUSTOMER_ORDER_CODE:this.postdata.CUSTOMER_ORDER_CODE,sessionId:this.sessionId}));
    //   }
    // },
      // 发送邮箱
      // sendCheckHandle(){
      //   let emailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
      //   if(!emailReg.test(this.email_value)){
      //      Toast('邮箱有误')
      //      return
      //   }else{
      //     this.isPop = false
      //     sendRequest({
      //       requestType: 'POST', //接口 是 get 还是post
      //       url: '/invoice/sendEmail', //接口地址
      //       isBody: false, // 必填get传false ,post传true
      //       body: {},//post 接口的参数
      //       params: {orderCode: this.postdata.SAMPLE_ORDER,email:this.email_value},
      //     }).then((res)=>{
      //          Toast(res.message)
      //     })
      //   }
      // },
        // 查列表
      selectlist(){
        sendRequest({
            requestType: 'POST', //接口 是 get 还是post
            url: '/limsOrderTable/selectOrder', //接口地址
            isBody: true, // 必填get传false ,post传true
            body: {isSubmit: "11",page: 1,rows: 20},//post 接口的参数
            params: {},
          }).then((res)=>{
              console.log(res,'list')
          })
      },
        // 查询发票详情
      selectInvoiceByOrderCode(){
          sendRequest({
            requestType: 'GET', //接口 是 get 还是post
            url: '/invoice/selectInvoiceByOrderCodeNew', //接口地址
            isBody: false, // 必填get传false ,post传true
            body: {},//post 接口的参数
            params: {orderCode: this.postdata.SAMPLE_ORDER},
          }).then((res)=>{
              this.postdata = res.data
              this.email = res.data.EMAIL 
          })
      }
    },
    created() {
      var result = this.getUrlParams(location.href);
      console.log(result);
      this.postdata.AUDIT_STATUS = result.AUDIT_STATUS;
      this.postdata.SAMPLE_ORDER = result.CUSTOMER_ORDER_CODE;
      this.sessionId = result.sessionId;
      console.log(this.postdata.SAMPLE_ORDER)
      //  this.selectInvoiceByOrderCode();
    },
    mounted() {
      this.selectInvoiceByOrderCode()
      window.NativeCallJS = (res) => {
        var par = JSON.parse(res);
        this.email = par.email
        console.log(res)
        if(par.isMailsubmit==1){
          sendRequest({
              requestType: 'POST', //接口 是 get 还是post
              url: '/invoice/sendEmail', //接口地址
              isBody: false, // 必填get传false ,post传true
              body: {},//post 接口的参数
              params: {orderCode: this.postdata.SAMPLE_ORDER,email:this.email},
            }).then((res)=>{
                Toast(res.message)
            })
        }
      }
      
    }
  }
</script>
<style lang="less" scoped>
  .invoiceBox {
    border-radius: 20px 20px 0px 0px;
    height: auto;
    background: #fff;
    padding: 20px 16px 0px 16px;
    margin-top: -10px;
    margin-bottom: 20px;
    .reson {
      width: 100%;
      height: 30px;
      background: #FFECEF;
      border-radius: 4px;
      display: flex;
      align-items: center;

      span {
        display: flex;
        padding-left: 24px;
        align-items: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF627F;
      }
    }

    .invoiceUrl {
      padding-top: 16px;
      width: 100%;
      position: relative;

      img {
        width: 100%;
        height: auto;
      }

      .invoiceDownLoad {
        width: 24px;
        height: 24px;
        background: rgba(47, 53, 77, 0.4000);
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 20px;
        right: 25%;
        border-radius: 100%;
        
        span {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }

      .urlHandle {
        width: 109px;
        height: 24px;
        background: rgba(47, 53, 77, 0.4000);
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 20px;
        left: 25%;

        span {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }

    .invoiceInfo {
      background: #F4F8FD;
      border-radius: 10px;
      margin-top: 20px;
      padding: 0px 24px 10px 24px;

      p {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2F354D;
        padding: 17px 0px 13px 0px;
        border-bottom: 1px solid #E3E5E8;
      }

      .invoiceRows {
        display: flex;
        justify-content: space-between;
        // align-items: center;
        padding-top: 7px;
        padding-bottom: 7px;
        // height: 32px;

        span:nth-of-type(1) {
          width: 30%;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9095A7;
        }

        span:nth-of-type(2) {
          width: 60%;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-align: end;
          color: #2F354D;
          font-size: 13px;
        }
      }
    }
  }

  .btns {
    width: 100%;
    position: fixed;
    bottom: 54px;
    display: flex;
    justify-content: center;

    span {
      width: 214px;
      height: 44px;
      background: linear-gradient(90deg, #6F9CFF 0%, #4B84FF 100%);
      box-shadow: 0px 6px 20px -2px rgba(75, 132, 255, 0.3000);
      border-radius: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 22px;
      letter-spacing: 1px;
    }
  }
  .sendEmail{
    position: fixed;
    width: 100%;
    display: flex;
    justify-content: center;
    top: 30%;
    .emailBox{
      width: 270px;
      background: #FFFFFF;
      border-radius: 10px;
      .pr{
        padding: 24px 24px 0px 24px;
        p:nth-of-type(1){
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2F354D;
          padding-bottom: 20px;
        }
        p:nth-of-type(2){
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2F354D;
          padding-bottom: 20px;
        }
        input{
          width: 100%;
          margin-bottom: 30px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2F354D;
          line-height: 22px;
          border-bottom: 1px solid #E3E5E8;
          padding-bottom: 10px;
        }
      }
      .cancleBtn{
        display: flex;
        width: 100%;
        border-top: 1px solid #D4D6DD;
        span{
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 45px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
        span:nth-of-type(1){
          color: #5F697D;
          border-right: 1px solid #D4D6DD;
        }
        span:nth-of-type(2){
          color: #4B84FF;
        }
        }
    }
  }
</style>